import ActiveMenuLink from 'active-menu-link'

document.addEventListener('DOMContentLoaded', () => {
  const productNavigations = document.querySelectorAll('.mtt-product-navigation')

  productNavigations.forEach(nav => {
    const panelGrid = nav.closest('.panel-grid')
    panelGrid.classList.add('mtt-product-navigation-sticky')

    calcIsSticky(panelGrid)

    window.addEventListener('scroll', () => {
      calcIsSticky(panelGrid)
    })
  })

  function calcIsSticky (element) {
    const offset = calcHeaderHeight()
    const elementBounding = element.getBoundingClientRect()
    const elementTop = elementBounding.top + window.scrollY
    if (window.scrollY + offset >= elementTop) {
      element.classList.add('is-sticky')
    } else {
      element.classList.remove('is-sticky')
    }
  }

  function calcHeaderHeight () {
    const MAIN_HEADER = document.querySelector('.mtt-header__main-nav').offsetHeight
    const ADMIN_BAR = document.getElementById('wpadminbar') ? document.getElementById('wpadminbar').offsetHeight : 0
    return MAIN_HEADER + ADMIN_BAR
  }

  new ActiveMenuLink('.mtt-product-navigation', {
    activeClass: 'mtt-product-navigation-link--active',
    headerHeight: 120
  })
})
